exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.minimap[data-v-578000ce] {\n    position: relative;\n    width: 360px;\n    height: 240px;\n}\n", ""]);

// exports
